@if (toggles[toggleName]) {
  <div class="callout secondary callout-help">
    <p [innerHTML]="textkey | translate"></p>
    <button
      type="button"
      class="close"
      (click)="toggles[toggleName] = !toggles[toggleName]"
      [attr.aria-label]="'arialabel.close' | translate"
    >
      <i class="icon-x"></i>
    </button>
  </div>
}
